var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#F8F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9375 17.6875L21.25 15.6875C21.0938 15.2812 20.7188 15 20.2812 15H20V11C20 8.8125 18.1875 7 16 7H14C11.7812 7 10 8.8125 10 11V15H9.6875C9.25 15 8.875 15.2812 8.75 15.6875L8.03125 17.6875C7.8125 18.3438 8.3125 19 9 19V22.75C9 22.9062 9.09375 23 9.25 23H9.75C9.875 23 10 22.9062 10 22.75V19H20V22.75C20 22.9062 20.0938 23 20.25 23H20.75C20.875 23 21 22.9062 21 22.75V19C21.6875 19 22.1562 18.3438 21.9375 17.6875ZM17 8.1875C18.1562 8.625 19 9.71875 19 11V15H17V8.1875ZM14 8H16V15H14V8ZM11 11C11 9.71875 11.8125 8.625 13 8.1875V15H11V11ZM9 18L9.6875 16H20.2812L21 18H9Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.7dcce25b.svg";
export { ForwardRef as ReactComponent };